import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from 'antd';
import useBrand from '../../hooks/context/useBrand';
import { brandLanguages } from '../../services/localization/brandLanguages';
import useApiClient from '../../hooks/api/useApiClient';
import useAuth from '../../hooks/auth/useAuth';

export default function LanguageSwitcher({ className }) {
  const { i18n } = useTranslation();
  const brand = useBrand();
  const { isLoggedIn } = useAuth();
  const { ConfigManager } = useApiClient();
  const currentLanguage = i18n.language;

  // The partner's region languages, primary first (ES/EN for Spain, DE/EN for FoodAmigos).
  const languages = brandLanguages(brand);

  /**
   * Persists the pick to the signed-in manager's own account so it follows them to
   * another browser. Guarded on auth because this switcher also renders on the login
   * page, where there is no manager to write to. Best-effort: the local change has
   * already taken effect, so a failed write costs only the cross-device part.
   *
   * Only an explicit pick is persisted — the language BrandProvider aligns to when the
   * brand settles is the partner's, not the operator's choice.
   */
  function updateLanguage(language) {
    try {
      i18n.changeLanguage(language);
    } catch (error) {
      console.error('Failed to change language', error);

      return;
    }

    isLoggedIn && ConfigManager.update({ lang: language });
  }

  if (languages.length < 2) {
    return null;
  }

  return (
    <Radio.Group
      options={languages.map((language) => ({ label: language.toUpperCase(), value: language }))}
      onChange={(e) => updateLanguage(e.target.value)}
      value={currentLanguage}
      defaultValue={currentLanguage}
      optionType="button"
      buttonStyle="solid"
      size="small"
      className={className}
    />
  );
}
